import React from 'react';
import { array, bool, func, string } from 'prop-types';

import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';

import ProfileObjectsTableRowMenu from './ProfileObjectsTableRowMenu';
import SelectAllCheckbox from '../../components/SelectAllCheckbox';

import classes from './ProfileObjectsTable.module.css';

const ProfileObjectsTable = ({
    isFullProfileAllowed,
    onSort,
    order,
    orderBy,
    onItemChange,
    onItemToggle,
    profileObjects,
    ...props
}) => {
    const isSortedByName = orderBy === 'name';
    const sortDirection = isSortedByName ? order : false;

    const handleItemToggle = event => {
        onItemToggle(event.target.value);
    };

    return (
        <div className={classes.tableWrapper}>
            <Table className={classes.table}>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.componentCell}>
                            <SelectAllCheckbox
                                items={profileObjects}
                                onItemChange={onItemChange}
                            />
                        </TableCell>
                        <TableCell
                            className={classes.headerCell}
                            onClick={onSort('name')}
                            sortDirection={sortDirection}
                        >
                            <Tooltip
                                title={
                                    <span className={classes.tooltip}>
                                        Sort
                                    </span>
                                }
                                placement="top-start"
                            >
                                <TableSortLabel
                                    active={isSortedByName}
                                    direction={order}
                                >
                                    Name
                                </TableSortLabel>
                            </Tooltip>
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                            Data Type
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                            Object Type
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                            Object Instance
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                            Property ID
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                            Array Index
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                            Interval
                        </TableCell>
                        <TableCell className={classes.componentCell} />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {profileObjects.map(profileObject => (
                        <TableRow key={profileObject.id}>
                            <TableCell padding="none">
                                <Checkbox
                                    checked={!!profileObject.isSelected}
                                    onChange={handleItemToggle}
                                    value={profileObject.id}
                                    color="primary"
                                    inputProps={{
                                        'aria-label': profileObject.isSelected ? 'Deselect Profile Object' : 'Select Profile Object'
                                    }}
                                />
                            </TableCell>
                            <TableCell
                                className={`${classes.dataCell} ${classes.ellipseCell}`}
                            >
                                <span>{profileObject.name}</span>
                            </TableCell>
                            <TableCell
                                className={`${classes.dataCell} ${classes.ellipseCell}`}
                            >
                                <span>{profileObject.dataType}</span>
                            </TableCell>
                            <TableCell
                                className={`${classes.dataCell} ${classes.ellipseCell}`}
                            >
                                <span>{profileObject.objectType}</span>
                            </TableCell>
                            <TableCell
                                className={`${classes.dataCell} ${classes.ellipseCell}`}
                            >
                                <span>{profileObject.objectId}</span>
                            </TableCell>
                            <TableCell
                                className={`${classes.dataCell} ${classes.ellipseCell}`}
                            >
                                <span>{profileObject.propertyId}</span>
                            </TableCell>
                            <TableCell
                                className={`${classes.dataCell} ${classes.ellipseCell}`}
                            >
                                <span>{profileObject.arrayIndex === -1 ? '-' : profileObject.arrayIndex}</span>
                            </TableCell>
                            <TableCell className={classes.dataCell}>
                                {profileObject.changeOfValue ? 'CoV' : profileObject.sampleInterval}
                            </TableCell>
                            <TableCell
                                className={classes.rowMenuCell}
                                padding="none"
                            >
                                <ProfileObjectsTableRowMenu
                                    hidden={!isFullProfileAllowed}
                                    onDelete={props.onDelete}
                                    onManage={props.onManage}
                                    object={profileObject}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};

ProfileObjectsTable.defaultProps = {
    profileObjects: [],
    onDelete:       () => {},
    onItemChange:   () => {},
    onItemToggle:   () => {},
    onManage:       () => {},
    onSort:         () => {}
};

ProfileObjectsTable.propTypes = {
    isFullProfileAllowed: bool,
    profileObjects:       array,
    onDelete:             func,
    onItemChange:         func,
    onItemToggle:         func,
    onManage:             func,
    onSort:               func,
    order:                string,
    orderBy:              string
};

export default ProfileObjectsTable;
